module.exports = __webpack_public_path__ + "img/1f920.c8b379e.svg";